import { PathMatch } from '@remix-run/router';
import { useMatch } from 'react-router-dom';

export const usePathMatch = (path: string): PathMatch | null => {
	return useMatch({
		path: path,
		end: path.length === 1,
	});
};
